import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function Pricing() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-143">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-145">
          <p className="text-lg md:text-xl text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-146">
            Sabemos que la salud en USA es impagable. Una sola cita con un
            nutricionista te costaría $150. Pero hoy, porque queremos que
            nuestra comunidad deje de sufrir de diabetes...
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-forest-dark mb-8" data-id="element-147">
            Llévatelo todo por un solo pago de:
          </h3>
        </motion.div>

        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="bg-cream-light border-2 border-gold rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto relative" data-id="element-148">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-alert text-white px-6 py-2 rounded-full font-bold text-sm tracking-wider uppercase shadow-lg" data-id="element-149">
            Oferta por Tiempo Limitado
          </div>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-150">
            <span className="text-2xl text-gray-400 line-through mb-2 font-bold" data-id="element-151">
              $252.00
            </span>
            <div className="flex items-start text-forest-dark" data-id="element-152">
              <span className="text-4xl font-bold mt-2" data-id="element-153">$</span>
              <span className="text-8xl font-black leading-none tracking-tighter" data-id="element-154">
                9.97
              </span>
              <span className="text-2xl font-bold mt-2 ml-2" data-id="element-155">USD</span>
            </div>
            <p className="text-alert font-semibold mt-4 text-lg" data-id="element-156">
              (Solo hoy. Mañana el precio vuelve a su valor original).
            </p>
          </div>

          <CtaButton className="w-full text-xl py-5" data-id="element-157" />
        </motion.div>
      </div>
    </section>;
}